module.exports = __webpack_public_path__ + "img/hk.a7745fb1.svg";